<template lang="html">
  <div class="container" id="text-page">
    <!-- <div v-html="row"></div> -->

    <h1 class="mb-3 page-title">Términos y Condiciones de uso</h1>
    <p>
      Bienvenido a ANLESA. Al acceder, navegar o utilizar esta plataforma digital, usted acepta expresamente sujetarse a los siguientes Términos y Condiciones de uso. Si no está de acuerdo con alguno de estos términos, le solicitamos abstenerse de utilizar nuestros servicios.
    </p>

    <br />
    <h5>1. Naturaleza del Servicio</h5>
    <p>
      ANLESA es un marketplace que actúa únicamente como intermediario tecnológico entre compradores y vendedores afiliados de productos locales y regionales. ANLESA no vende, almacena ni distribuye productos, y por lo tanto no asume ninguna responsabilidad sobre la calidad, cumplimiento, entrega o garantía de los bienes ofrecidos.
    </p>

    <br />
    <h5>2. Responsabilidad del Vendedor</h5>
    <p>
      Cada vendedor afiliado es el único responsable del contenido de su tienda, la información publicada, la veracidad de las descripciones, el cumplimiento de los pedidos, las políticas de devolución y la atención al cliente. ANLESA no garantiza ni verifica la autenticidad de los productos ofrecidos por terceros.
    </p>

    <br />
    <h5>3. Responsabilidad del Comprador</h5>
    <p>
      El comprador es responsable de leer y entender toda la información publicada por el vendedor antes de concretar una compra. Esto incluye precios, tiempos de envío, condiciones de devolución y demás términos aplicables. Al realizar una compra, el comprador establece una relación comercial directa con el vendedor.
    </p>

    <br />
    <h5>4. Contenido y conducta del usuario</h5>
    <p>
      Los usuarios se comprometen a utilizar ANLESA de manera ética, legal y respetuosa. Queda prohibido el uso de lenguaje ofensivo, la publicación de contenido falso, el intento de fraude o cualquier comportamiento que atente contra la integridad de la comunidad o el funcionamiento de la plataforma.
    </p>

    <br />
    <h5>5. Limitación de responsabilidad</h5>
    <p>
      ANLESA no será responsable por pérdidas, daños directos o indirectos, incumplimientos o perjuicios derivados de las transacciones entre compradores y vendedores, ni por errores u omisiones en el contenido publicado por terceros.
    </p>

    <br />
    <h5>6. Modificaciones</h5>
    <p>
      ANLESA se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento y sin previo aviso. Las modificaciones entrarán en vigor desde su publicación en la plataforma. El uso continuado de ANLESA constituye la aceptación de dichos cambios.
    </p>

    <br />
    <h5>7. Jurisdicción</h5>
    <p>
      Estos Términos y Condiciones se rigen por las leyes vigentes en México. En caso de controversia, ambas partes se someten a la jurisdicción de los tribunales competentes en la ciudad de Guadalajara, Jalisco, renunciando a cualquier otro fuero que pudiera corresponderles.
    </p>
  </div>
</template>

<script>
export default {
  data(){
    return{
      row:null,
    }
  },

  methods: {
    getData: function(){
      axios.get(tools.url('/api/terminos')).then((response)=>{
        this.row = response.data.body;
      }).catch((error)=>{
      })
    },
  },

  mounted(){
      this.getData();
  },
}
</script>
